import { JOB_STATES, QUEUE_NAMES } from '@steado/admin-contract/jobs';
import { z } from 'zod';

/**
 * The queue, the state and the page offset live in the URL, so "the failed
 * plan-generation jobs" is a link an operator can paste into an incident
 * channel.
 *
 * Defaults match the API's: the first queue and its failed jobs, which is what
 * this screen is opened for.
 */
export const jobsSearchSchema = z.object({
  queue: z.enum(QUEUE_NAMES).default('plan-generation').catch('plan-generation'),
  state: z.enum(JOB_STATES).default('failed').catch('failed'),
  offset: z.coerce.number().int().min(0).default(0).catch(0),
  job: z.string().min(1).max(64).optional().catch(undefined),
});

export type JobsSearch = z.infer<typeof jobsSearchSchema>;
